import {createTheme} from "@mui/material";
import '../sass/app.scss'
import {orange} from "@mui/material/colors";

const GciTheme = createTheme({
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        color: 'rgba(0, 0, 0, 0.6)', // Replace with your color
                    },
                    fontFamily: 'Gotham-Bold',
                    whiteSpace: 'normal',
                }
            },
            defaultProps: {
                shrink: true
            }
        },
        MuiOutlinedInput: {
            defaultProps: {
                sx: {
                    '&:hover': {
                        bgcolor: 'primary.light',
                    },
                    "&:focus-within": {
                        bgcolor: 'primary.light',
                    },
                    minHeight: '3rem'
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
            }
        },
        MuiFormHelperText: {
            defaultProps: {
                color: 'white',
            },
            styleOverrides: {
                root: ({ownerState, theme}) => ({
                    color: ownerState.error ? theme.palette.error.main : undefined,
                })
            }
        }
    },
    palette: {
        primary: {
            main: '#00A9E0',
            light: '#F3FCFF',
            dark: '#0084B0'
        },
        error: {
            main: '#E50000',
            light: '#E58989',
            dark: '#B40000'
        },
        success: {
            main: '#188623',
            light: '#F2FDF3',
            dark: '#13691B'
        },
        gciRed: {
            main: '#B71234',
            light: '#D3153B',
            dark: '#850D25',
            contrastText: '#fff',
        },
        glacierBlue: {
            main: '#00A9E0',
            light: '#00BFFE',
            dark: '#006384',
            contrastText: '#000',
        },
        midnightBlue: {
            main: '#042046',
            light: '#073473',
            dark: '#031835',
            contrastText: '#fff',
        },
        scale: {
            white: '#031835',
            light: '#F2F5FA',
            middle: '#BDBFC6',
            dark: '#66646F',
            almost_black: '#312E3B'
        }
    },
    typography: {
        fontFamily: 'Gotham-Book',
        fontWeightMedium: 600,
        // h1: {
        //     fontFamily: 'Trailblazer-Bold'
        // },
        // h2: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // h3: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // h4: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // h5: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // h6: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // subtitle1: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // subtitle2: {
        //     fontFamily: 'Gotham-Bold'
        // },
        // body2: {
        //     fontFamily: 'Gotham-Bold'
        // },
        body1: {
            fontFamily: 'Gotham-Book'
        },
        caption: {
            // FormHelperText
            fontFamily: 'Gotham-Bold',
            fontSize: '0.625rem',
        },
    }
})

declare module '@mui/material/styles' {

    interface Palette {
        gciRed: Palette['primary'],
        glacierBlue: Palette['primary'],
        midnightBlue: Palette['primary'],
        scale: Palette['primary'],
    }

    interface PaletteOptions {
        gciRed: PaletteOptions['primary'],
        glacierBlue: PaletteOptions['primary'],
        midnightBlue: PaletteOptions['primary'],
        scale: {
            white: string,
            light: string,
            middle: string,
            dark: string,
            almost_black: string
        }
    }

    interface PaletteColor {
        darker?: string;
    }

    interface SimplePaletteColorOptions {
        darker?: string;
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        gciRed: true;
        glacierBlue: true;
        midnightBlue: true;
    }
}

export default GciTheme
